import { SlTitledListComponent } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import TransactionsSectionList from 'shared/components/TransactionSectionList/TransactionSectionList';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import { amountStyles } from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

export interface HistoryTabProps {
  closedLoans?: SlTitledListComponent[];
}

const HistoryTab = ({ closedLoans }: HistoryTabProps) => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('payOverTime', {
    keyPrefix: 'manageLoans',
  });

  const navigateToDetails = (id: string) => {
    router.navigate({
      pathname: '/pay-over-time/history-details',
      params: {
        loanId: id,
      },
    });
  };

  const mapToHistoryTransactionSectionList = (
    section: SlTitledListComponent,
  ) => {
    return {
      title: section.title?.copy || '',
      transactions: section.children.map((transaction) => {
        return {
          titleText: transaction.primaryText?.copy || '',
          secondaryText: transaction.secondaryText?.copy || '',
          amountText: transaction.primaryDetail?.copy || '',
          balanceText: transaction.secondaryDetail?.copy || '',
          secondaryDetail: transaction.secondaryDetail?.copy || '',
          isPending: false,
          amountStyle: amountStyles.NEUTRAL,
          onPress: () => navigateToDetails(transaction.id),
        };
      }),
    };
  };

  return (
    <View style={styles.screen}>
      {closedLoans?.length && closedLoans?.length > 0 ? (
        <TransactionsSectionList
          transactions={closedLoans.map(mapToHistoryTransactionSectionList)}
          scrollEnabled={false}
        />
      ) : (
        <View style={styles.emptyStateContainer}>
          <View style={styles.image}>
            <Illustration illustration="COINS_C" />
          </View>
          <BodyBaseText style={styles.emptyText}>
            {translatedText('emptyHistory')}
          </BodyBaseText>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  emptyStateContainer: {
    alignItems: 'center',
    flex: 1,
  },
  emptyText: {
    color: theme.color.text.secondary,
  },
  image: {
    height: 131,
    width: 131,
  },
  screen: {
    flex: 1,
  },
});

export default HistoryTab;
